import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI || 'http://localhost:3080/v1/callback';
const BACKEND = process.env.REACT_APP_BACKEND || 'http://localhost:8000';

export default function CallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const errorDesc = searchParams.get('error_description');

    if (errorDesc || !code) {
      navigate('/', { replace: true });
      return;
    }

    const savedState = localStorage.getItem('oauth_state');
    if (state !== savedState) {
      localStorage.removeItem('oauth_state');
      navigate('/', { replace: true });
      return;
    }

    localStorage.removeItem('oauth_state');

    fetch(`${BACKEND}/api/auth/callback`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code, redirect_uri: REDIRECT_URI }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) throw new Error(data.error);

        localStorage.setItem('konet_token', data.accessToken);
        localStorage.setItem('konet_user', JSON.stringify(data.user));
        localStorage.setItem('konet_token_expiry', String(Date.now() + 7200 * 1000));

        // ←←← THIS IS THE KEY CHANGE
        const redirectTo = localStorage.getItem('login_redirect_to') || '/';
        
        localStorage.removeItem('login_redirect_to');

        navigate(redirectTo, { replace: true });
      })
      .catch(err => {
        console.error(err);
        navigate('/', { replace: true });
      });
  }, [searchParams, navigate]);

  return <div style={{height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
    Completing sign-in...
  </div>;
}